export default "__VITE_ASSET__C3HT8gv0__"